var parseVersion = function(str) {
	// see webpack/lib/util/semver.js for original code
	var p=function(p){return p.split(".").map((function(p){return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = function(a, b) {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = function(range) {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = function(range, version) {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = function(scopeName, key) {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = function(scope, key) {
	var versions = scope[key];
	var key = Object.keys(versions).reduce(function(a, b) {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = function(scope, key) {
	var versions = scope[key];
	return Object.keys(versions).reduce(function(a, b) {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = function(key, version, requiredVersion) {
	return "Unsatisfied version " + version + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingletonVersion = function(scope, scopeName, key, requiredVersion) {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) typeof console !== "undefined" && console.warn && console.warn(getInvalidSingletonVersionMessage(key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = function(scope, scopeName, key, requiredVersion) {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = function(scope, key, requiredVersion) {
	var versions = scope[key];
	var key = Object.keys(versions).reduce(function(a, b) {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = function(scope, scopeName, key, requiredVersion) {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map(function(key) {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = function(scope, scopeName, key, requiredVersion) {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warnInvalidVersion = function(scope, scopeName, key, requiredVersion) {
	typeof console !== "undefined" && console.warn && console.warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = function(entry) {
	entry.loaded = 1;
	return entry.get()
};
var init = function(fn) { return function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
}; };

var load = /*#__PURE__*/ init(function(scopeName, scope, key) {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init(function(scopeName, scope, key, fallback) {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	2135: function() { return loadSingletonVersionCheckFallback("default", "@angular/common", [1,12,0,0], function() { return function() { return __webpack_require__(/*! @angular/common */ 38583); }; }); },
	42773: function() { return loadStrictVersionCheckFallback("default", "rxjs/operators", [4,6,6,7], function() { return function() { return __webpack_require__(/*! rxjs/operators */ 30397); }; }); },
	20947: function() { return loadSingletonVersionCheckFallback("default", "@savvaslearning/lst-events", [4,1,0,2], function() { return function() { return __webpack_require__(/*! @savvaslearning/lst-events */ 82799); }; }); },
	92979: function() { return loadSingletonVersionCheckFallback("default", "@angular/core", [1,12,2,0], function() { return function() { return __webpack_require__(/*! @angular/core */ 37716); }; }); },
	720: function() { return loadStrictVersionCheckFallback("default", "rxjs", [4,6,6,7], function() { return function() { return __webpack_require__(/*! rxjs */ 765); }; }); },
	71499: function() { return loadSingletonVersionCheckFallback("default", "@angular/core", [1,12,0,0], function() { return function() { return __webpack_require__(/*! @angular/core */ 37716); }; }); },
	75065: function() { return loadStrictVersionCheckFallback("default", "rxjs", [,[1,7,0,0],[1,6,5,3],1], function() { return function() { return __webpack_require__(/*! rxjs */ 765); }; }); },
	2038: function() { return loadStrictVersionCheckFallback("default", "rxjs/operators", [,[1,7,0,0],[1,6,5,3],1], function() { return function() { return __webpack_require__(/*! rxjs/operators */ 30397); }; }); },
	45278: function() { return loadSingletonVersionCheckFallback("default", "@angular/common/http", [1,12,0,0], function() { return function() { return __webpack_require__(/*! @angular/common/http */ 91841); }; }); },
	12354: function() { return loadFallback("default", "@angular/common", function() { return function() { return __webpack_require__(/*! @angular/common */ 38583); }; }); },
	92852: function() { return loadSingletonVersionCheckFallback("default", "@angular/core", [4,12,2,17], function() { return function() { return __webpack_require__(/*! @angular/core */ 37716); }; }); },
	1662: function() { return loadSingletonVersionCheckFallback("default", "@savvaslearning/lst-auth", [1,2,0,4], function() { return function() { return __webpack_require__(/*! @savvaslearning/lst-auth */ 76902); }; }); },
	27850: function() { return loadSingletonVersionCheckFallback("default", "@angular/common", [4,12,0,0], function() { return function() { return __webpack_require__(/*! @angular/common */ 38583); }; }); },
	68594: function() { return loadSingletonVersionCheckFallback("default", "@angular/common/http", [4,12,0,0], function() { return function() { return __webpack_require__(/*! @angular/common/http */ 91841); }; }); },
	49488: function() { return loadSingletonVersionCheckFallback("default", "@angular/core", [4,12,0,0], function() { return function() { return __webpack_require__(/*! @angular/core */ 37716); }; }); },
	66179: function() { return loadFallback("default", "rxjs", function() { return function() { return __webpack_require__(/*! rxjs */ 765); }; }); },
	29461: function() { return loadFallback("default", "@angular/router", function() { return function() { return __webpack_require__(/*! @angular/router */ 39895); }; }); },
	93317: function() { return loadSingletonVersionCheckFallback("default", "@angular/common", [4,12,2,17], function() { return function() { return __webpack_require__(/*! @angular/common */ 38583); }; }); },
	25444: function() { return loadFallback("default", "rxjs/operators", function() { return function() { return __webpack_require__(/*! rxjs/operators */ 30397); }; }); },
	87277: function() { return loadSingletonVersionCheckFallback("default", "apollo-angular", [1,1,9,1], function() { return function() { return __webpack_require__(/*! apollo-angular */ 550); }; }); },
	75831: function() { return loadSingletonVersionCheckFallback("default", "@angular/core", [,[1,10,0,0],[1,9,0,0],[1,8,0,0],[1,7,0,0],[1,6,1,0],1,1,1,1], function() { return function() { return __webpack_require__(/*! @angular/core */ 37716); }; }); },
	89239: function() { return loadSingletonVersionCheckFallback("default", "apollo-client", [1,2,3,4], function() { return function() { return __webpack_require__(/*! apollo-client */ 21667); }; }); },
	53137: function() { return loadStrictVersionCheckFallback("default", "rxjs", [1,6,0,0], function() { return function() { return __webpack_require__(/*! rxjs */ 765); }; }); },
	33159: function() { return loadStrictVersionCheckFallback("default", "rxjs/operators", [1,6,0,0], function() { return function() { return __webpack_require__(/*! rxjs/operators */ 30397); }; }); },
	29952: function() { return loadSingletonVersionCheckFallback("default", "@ngx-translate/core", [1,13,0,0], function() { return function() { return __webpack_require__(/*! @ngx-translate/core */ 29790); }; }); },
	58459: function() { return loadSingletonVersionCheckFallback("default", "@angular/core", [0,10,0,0], function() { return function() { return __webpack_require__(/*! @angular/core */ 37716); }; }); },
	92253: function() { return loadStrictVersionCheckFallback("default", "rxjs", [0,6,5,3], function() { return function() { return __webpack_require__(/*! rxjs */ 765); }; }); },
	21009: function() { return loadStrictVersionCheckFallback("default", "rxjs/operators", [0,6,5,3], function() { return function() { return __webpack_require__(/*! rxjs/operators */ 30397); }; }); },
	37705: function() { return loadSingletonVersionCheckFallback("default", "@angular/core", [,[1,10,0,0],[1,9,0,0],[1,8,0,0],[1,7,0,0],[1,6,0,0],1,1,1,1], function() { return function() { return __webpack_require__(/*! @angular/core */ 37716); }; }); },
	70848: function() { return loadSingletonVersionCheckFallback("default", "@angular/common/http", [,[1,10,0,0],[1,9,0,0],[1,8,0,0],[1,7,0,0],[1,6,0,0],1,1,1,1], function() { return function() { return __webpack_require__(/*! @angular/common/http */ 91841); }; }); },
	87125: function() { return loadSingletonVersionCheckFallback("default", "@angular/router", [1,12,0,0], function() { return function() { return __webpack_require__(/*! @angular/router */ 39895); }; }); }
};
var initialConsumes = [71499,75065,2038,45278,12354,92852,1662,27850,68594,49488,66179,29461,93317,25444,87277,75831,89239,53137,33159,29952,58459,92253,21009,37705,70848,87125];
initialConsumes.forEach(function(id) {
	__webpack_require__.m[id] = function(module) {
		// Handle case when module is used sync
		installedModules[id] = 0;
		delete __webpack_require__.c[id];
		var factory = moduleToHandlerMapping[id]();
		if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
		module.exports = factory();
	}
});
var chunkMapping = {
	"default-src_app_components_google-class_google-class_module_ts": [
		2135,
		42773,
		20947,
		92979
	],
	"src_app_components_standalone_standalone_module_ts": [
		720
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			var onFactory = function(factory) {
				installedModules[id] = 0;
				__webpack_require__.m[id] = function(module) {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			var onError = function(error) {
				delete installedModules[id];
				__webpack_require__.m[id] = function(module) {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory).catch(onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
		});
	}
}